<router-outlet></router-outlet>

<div
  class="embed-gallery-page"
  [style.--gallery-background-color]="gallery.layout_background_color"
  [class.dark]="darkGalleryBackground"
>
  <div
    class="cover-container"
    [class.has-asset]="gallery.cover.uuid"
    [style.--color-primary]="gallery.primary_color"
    *ngIf="(gallery.cover.uuid || gallery.title || gallery.description) && !hideCover"
  >
    <div
      class="cover size-{{ gallery.cover.uuid ? gallery.cover.size : 'none' }}"
      [class.content-left]="gallery.cover.content_position?.[0] === 0"
      [class.content-right]="gallery.cover.content_position?.[0] === 1"
      [class.content-top]="gallery.cover.content_position?.[1] === 0"
      [class.content-bottom]="gallery.cover.content_position?.[1] === 1"
    >
      <div class="cover-asset" *ngIf="gallery.cover?.uuid && platformBrowser" #el>
        <img
          *ngIf="!gallery.cover.video_origin"
          [src]="
            gallery.cover?.uuid
              | galleryCoverUrl : gallery.cover.width : gallery.cover.height : el.clientWidth : el.clientHeight
              | async
          "
          alt=""
          onload="this.className='loaded'"
          [style.object-position]="gallery.cover.position"
        />
        <ng-container *ngIf="gallery.cover.video_origin">
          <app-video-viewer
            [videoData]="$any(gallery.cover)"
            [uuid]="gallery.cover.uuid"
            [origin]="gallery.cover.video_origin"
            [poster]="
              gallery.cover?.uuid
                | galleryCoverUrl : gallery.cover.width : gallery.cover.height : el.clientWidth : el.clientHeight
                | async
            "
            [active]="true"
            [showUi]="false"
            [autoPlay]="true"
            [muted]="true"
            [loop]="true"
            [cover]="true"
            [coverPosition]="gallery.cover.position"
            [targetWidth]="el.clientWidth"
          ></app-video-viewer>
        </ng-container>
      </div>
      <div class="cover-asset server-cover" *ngIf="gallery.cover?.uuid && !platformBrowser" #el></div>
      <div
        class="cover-overlay"
        *ngIf="gallery.cover?.uuid && platformBrowser"
        [style.backgroundColor]="gallery.cover?.overlay_color || 'transparent'"
      ></div>
      <div class="cover-content">
        <h1
          *ngIf="gallery.title"
          [style.color]="gallery.cover.title_typography?.font_color || gallery.default_title_typography?.font_color"
          [style.fontFamily]="
            (gallery.cover.title_typography?.font_family || gallery.default_title_typography?.font_family) +
            ', AkkuratLL'
          "
          class="{{ getFontSize(gallery.cover?.title_typography?.font_size) }}"
        >
          {{ gallery.title }}
        </h1>
        <h3
          *ngIf="gallery.description"
          [style.color]="
            gallery.cover.paragraph_typography?.font_color || gallery.default_paragraph_typography?.font_color
          "
          [style.fontFamily]="
            gallery.cover.paragraph_typography?.font_family ||
            gallery.default_paragraph_typography?.font_family + ', AkkuratLL'
          "
          class="{{ getFontSize(gallery.cover?.paragraph_typography?.font_size) }}"
          [innerHTML]="galleryDescription"
        ></h3>
      </div>
    </div>
  </div>

  <div #galleryBody>
    <ng-container *ngIf="platformBrowser">
      <ng-container *ngFor="let section of sections; let i = index">
        <div class="page section-page" *ngIf="section.object === 'gallery'">
          <app-album-section
            [section]="toAlbumSection(section)"
            [parentGallery]="gallery"
            [embedMode]="true"
          ></app-album-section>
        </div>
        <div class="page full section-page text-section-page" *ngIf="section.object === 'text'">
          <app-text-section
            [section]="toTextSection(section)"
            [gallery]="gallery"
            [darkGalleryBackground]="darkGalleryBackground"
          ></app-text-section>
        </div>
        <app-assets-section
          [section]="toAssetSection(section)"
          [gallery]="gallery"
          *ngIf="section.object === 'asset' && section.position !== 612512"
          [embedMode]="true"
          [blockEmbedAssetView]="blockAssetView"
          [darkGalleryBackground]="darkGalleryBackground"
        >
        </app-assets-section>
        <app-embed-section [section]="toEmbedSection(section)" [gallery]="gallery" *ngIf="section.object === 'embed'">
        </app-embed-section>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!platformBrowser">
      <div class="page center tiny loading">
        <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
      </div>
    </ng-container>
  </div>
</div>
